import React from 'react';
import withLayout from '../../components/layout';
import MyNotifications from '../../components/feature/my-notifications';
import { ROUTE_PATH } from '../../constants/route-constants';

const Notifications = () => {
    return (
        <MyNotifications />
    );
};

export default withLayout(Notifications, true, false, { search: false, wisList: false, notification: false, backRoute: ROUTE_PATH.EXPLORE, title: 'NOTIFICATIONS', back: true, position: 'sticky' });;
